import storageManager from '@/utils/storageManager'
import apiClient from '@/utils/apiClient'

const AuthModule = {
  namespaced: true,
  state: {
    token: storageManager.getToken() || "",
    status: ""
  },
  getters: {
    isAuthenticated: state => !!state.token,
    status: state => state.status
  },
  actions: {
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("REQUESTING")
        apiClient.logIn(user)
          .then((response) => {
            const token = response.data.token
            apiClient.setToken(token)
            storageManager.setToken(token)
            commit("SUCCESS", token)
            resolve(response)
          })
          .catch((error) => {
            commit("ERROR")
            apiClient.removeToken()
            storageManager.removeToken()
            reject(error)
          })
      })
    },
    logout ({ commit }) {
      commit("LOGOUT")
      apiClient.removeToken()
      storageManager.removeToken()
      return Promise.resolve()
    }
  },
  mutations: {
    REQUESTING: (state) => {
      state.status = "loading"
    },
    SUCCESS: (state, token) => {
      state.status = "success"
      state.token = token
    },
    ERROR: (state) => {
      state.status = "error"
    },
    LOGOUT: (state) => {
      state.status = "error"
      state.token = ""
    }
  }
}

export default AuthModule
